export default __webpack_public_path__ + "static/media/stockholmchocolate@3x.abfef010.jpg";